import { z } from 'zod';

export const UseOwnLlmSchema = z.object({
  useOwnLlm: z.boolean(),
});

export type IUseOwnLlmDto = z.infer<typeof UseOwnLlmSchema>;
